import React from "react";

function CollegeDetails() {
  return (
    <div className="page">
      <h1 className="page-title">College Details</h1>

      <div className="content-card">
        <h2 className="section-title">What We Offer</h2>

        <div className="courses-grid">
          <div className="course-card">(B.B.A) Bachelor of Business Administration</div>
          <div className="course-card">(B.C.A) Bachelor of Computer Applications</div>
          <div className="course-card">B.Sc Honours Computer Science</div>
          <div className="course-card">B.Sc Honours Botany</div>
          <div className="course-card">B.Sc Honours Maths</div>
          <div className="course-card">B.Sc Honours Zoology</div>
          <div className="course-card">B.Com Honours Computer Applications</div>
          {/* <div className="course-card">B.Com Honours Accounting</div> */}
        </div>

        <h2 className="section-title">Infrastructure</h2>
        <p>
          Blue Moon Degree College provides a well-planned campus with modern
          classrooms, fully equipped science and computer laboratories,
          library facilities, seminar halls, and sports infrastructure to
          support overall student development.
        </p>

        <h2 className="section-title">Affiliation</h2>
        <p>
          The college is <strong>affiliated to Sri Krishnadevaraya University</strong>
          and follows the academic guidelines prescribed by the university.
        </p>
      </div>
    </div>
  );
}

export default CollegeDetails;
